export default "__VITE_ASSET__CzTkqZYM__"